
/**
 * 角度归一化到 [0, 360)
 * @param angleDeg 原始角度（度）
 * @returns 归一化后角度（度）
 */
export function normalizeAngleDegrees(angleDeg: number): number {
    let normalized = angleDeg % 360;
    if (normalized < 0) {
        normalized += 360;
    }
    return normalized;
}
